import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_85a287b0 from 'nuxt_plugin_sentryserver_85a287b0' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_57754aa0 from 'nuxt_plugin_sentryclient_57754aa0' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vlazyload_2544e252 from 'nuxt_plugin_vlazyload_2544e252' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_portalvue_6589ea6f from 'nuxt_plugin_portalvue_6589ea6f' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_dayjsplugin_1a86800e from 'nuxt_plugin_dayjsplugin_1a86800e' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_toast_17d1ed13 from 'nuxt_plugin_toast_17d1ed13' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_apollomodule_32006fa0 from 'nuxt_plugin_apollomodule_32006fa0' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_storage_8f945902 from 'nuxt_plugin_storage_8f945902' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_libpluginc1def7bc_f826a572 from 'nuxt_plugin_libpluginc1def7bc_f826a572' // Source: ./lib.plugin.c1def7bc.js (mode: 'all')
import nuxt_plugin_libmoduleplugin1e0320f0_6470ca13 from 'nuxt_plugin_libmoduleplugin1e0320f0_6470ca13' // Source: ./lib.module.plugin.1e0320f0.js (mode: 'all')
import nuxt_plugin_srcplugintemplate54deb667_2c7671fc from 'nuxt_plugin_srcplugintemplate54deb667_2c7671fc' // Source: ./src.plugin.template.54deb667.js (mode: 'all')
import nuxt_plugin_sanity_3e989426 from 'nuxt_plugin_sanity_3e989426' // Source: ./sanity.js (mode: 'all')
import nuxt_plugin_globalcomponents_d82bb6cc from 'nuxt_plugin_globalcomponents_d82bb6cc' // Source: ./global-components.js (mode: 'all')
import nuxt_plugin_polyfills_388ffffe from 'nuxt_plugin_polyfills_388ffffe' // Source: ../plugins/polyfills (mode: 'client')
import nuxt_plugin_gsap_559c063e from 'nuxt_plugin_gsap_559c063e' // Source: ../plugins/gsap (mode: 'client')
import nuxt_plugin_nuxtpreviewinit_3853c50e from 'nuxt_plugin_nuxtpreviewinit_3853c50e' // Source: ../plugins/nuxt-preview-init (mode: 'client')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../plugins/gtm (mode: 'client')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249' // Source: ../plugins/gtag (mode: 'client')
import nuxt_plugin_refersion_19172fa2 from 'nuxt_plugin_refersion_19172fa2' // Source: ../plugins/refersion (mode: 'client')
import nuxt_plugin_klaviyo_e863c0ba from 'nuxt_plugin_klaviyo_e863c0ba' // Source: ../plugins/klaviyo (mode: 'client')
import nuxt_plugin_amazon_4614db4a from 'nuxt_plugin_amazon_4614db4a' // Source: ../plugins/amazon (mode: 'client')
import nuxt_plugin_hotjar_522b5bf4 from 'nuxt_plugin_hotjar_522b5bf4' // Source: ../plugins/hotjar (mode: 'client')
import nuxt_plugin_vueobservevisibility_c32a0d60 from 'nuxt_plugin_vueobservevisibility_c32a0d60' // Source: ../plugins/vue-observe-visibility (mode: 'client')
import nuxt_plugin_vuea11yutils_30229ae9 from 'nuxt_plugin_vuea11yutils_30229ae9' // Source: ../plugins/vue-a11y-utils (mode: 'client')
import nuxt_plugin_vueawesomeswiper_09a6108f from 'nuxt_plugin_vueawesomeswiper_09a6108f' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_veevalidate_81ef739a from 'nuxt_plugin_veevalidate_81ef739a' // Source: ../plugins/vee-validate (mode: 'client')
import nuxt_plugin_vueclickoutside_7f633153 from 'nuxt_plugin_vueclickoutside_7f633153' // Source: ../plugins/vue-click-outside (mode: 'client')
import nuxt_plugin_vuemovedom_5bbf3e73 from 'nuxt_plugin_vuemovedom_5bbf3e73' // Source: ../plugins/vue-move-dom (mode: 'client')
import nuxt_plugin_vueodometer_4b94e888 from 'nuxt_plugin_vueodometer_4b94e888' // Source: ../plugins/vue-odometer (mode: 'client')
import nuxt_plugin_vuefontawesome_168dae32 from 'nuxt_plugin_vuefontawesome_168dae32' // Source: ../plugins/vue-fontawesome (mode: 'all')
import nuxt_plugin_vuehoverintent_460e36fa from 'nuxt_plugin_vuehoverintent_460e36fa' // Source: ../plugins/vue-hover-intent (mode: 'client')
import nuxt_plugin_aspire_466ffa64 from 'nuxt_plugin_aspire_466ffa64' // Source: ../plugins/aspire (mode: 'client')
import nuxt_plugin_eventbus_2c6065c7 from 'nuxt_plugin_eventbus_2c6065c7' // Source: ../plugins/event-bus (mode: 'all')
import nuxt_plugin_sanityimage_65558462 from 'nuxt_plugin_sanityimage_65558462' // Source: ../plugins/sanity-image (mode: 'all')
import nuxt_plugin_sanitystudio_56d72faf from 'nuxt_plugin_sanitystudio_56d72faf' // Source: ../plugins/sanity-studio (mode: 'client')
import nuxt_plugin_dayjs_5e48f842 from 'nuxt_plugin_dayjs_5e48f842' // Source: ../plugins/dayjs (mode: 'all')
import nuxt_plugin_numeral_3a7ded98 from 'nuxt_plugin_numeral_3a7ded98' // Source: ../plugins/numeral (mode: 'all')
import nuxt_plugin_slugify_3412fbeb from 'nuxt_plugin_slugify_3412fbeb' // Source: ../plugins/slugify (mode: 'all')
import nuxt_plugin_pluralize_5e64ff6c from 'nuxt_plugin_pluralize_5e64ff6c' // Source: ../plugins/pluralize (mode: 'all')
import nuxt_plugin_sanitymixin_658c6788 from 'nuxt_plugin_sanitymixin_658c6788' // Source: ../plugins/sanity-mixin (mode: 'all')
import nuxt_plugin_colormixin_6ac7ffde from 'nuxt_plugin_colormixin_6ac7ffde' // Source: ../plugins/color-mixin (mode: 'all')
import nuxt_plugin_textareaautogrowdirective_50d87671 from 'nuxt_plugin_textareaautogrowdirective_50d87671' // Source: ../plugins/textarea-autogrow-directive (mode: 'all')
import nuxt_plugin_vueresizeobserver_dccea3fc from 'nuxt_plugin_vueresizeobserver_dccea3fc' // Source: ../plugins/vue-resize-observer (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Recess","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":"drinks and powders to help you feel calm cool collected despite the stressful world around you"},{"hid":"facebookImage","name":"og:image","content":"https:\u002F\u002Ftakearecess.co\u002Fmeta-image.jpg"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"@takearecess"},{"hid":"twitterTitle","name":"twitter:title","content":"Recess"},{"hid":"twitterDescription","name":"twitter:description","content":"drinks and powders to help you feel calm cool collected despite the stressful world around you"},{"hid":"twitterImage","name":"twitter:image","content":"https:\u002F\u002Ftakearecess.co\u002Fmeta-image.jpg"},{"hid":"color","name":"theme-color","content":"rgba(162, 176, 255, 1)"},{"name":"google-site-verification","content":"omBfbYn2k0HjI8wF7xqAEW7fZ304yWivwB3fxlhWles"}],"link":[{"hid":"icon-16x16","rel":"icon","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"hid":"icon-32x32","rel":"icon","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"hid":"icon-128x128","rel":"icon","sizes":"128x128","href":"\u002Ffavicon-128x128.png"},{"hid":"icon-192x192","rel":"icon","sizes":"192x192","href":"\u002Ffavicon-192x192.png"},{"rel":"preload","as":"font","type":"font\u002Fwoff","href":"\u002Ffonts\u002Fantidote\u002FAntidoteDisplay.woff","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff","href":"\u002Ffonts\u002Fsharp-grotesk\u002FSharpGroteskBook20.woff","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff","href":"\u002Ffonts\u002Fsharp-grotesk\u002FSharpGroteskMedium23.woff","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff","href":"\u002Ffonts\u002Fsharp-grotesk\u002FSharpGroteskSmBold23.woff","crossorigin":true}],"script":[{"src":"https:\u002F\u002Ftakearecess.refersion.com\u002Ftracker\u002Fv3\u002Fpub_e7cbdfcb148861fe3b08.js"},{"src":"https:\u002F\u002Fstatic.klaviyo.com\u002Fonsite\u002Fjs\u002Fklaviyo.js?company_id=PLmtE4","async":true,"type":"text\u002Fjavascript"},{"src":"https:\u002F\u002Fwww.dwin1.com\u002F19038.js","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_85a287b0 === 'function') {
    await nuxt_plugin_sentryserver_85a287b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_57754aa0 === 'function') {
    await nuxt_plugin_sentryclient_57754aa0(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_2544e252 === 'function') {
    await nuxt_plugin_vlazyload_2544e252(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_6589ea6f === 'function') {
    await nuxt_plugin_portalvue_6589ea6f(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_1a86800e === 'function') {
    await nuxt_plugin_dayjsplugin_1a86800e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_17d1ed13 === 'function') {
    await nuxt_plugin_toast_17d1ed13(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_32006fa0 === 'function') {
    await nuxt_plugin_apollomodule_32006fa0(app.context, inject)
  }

  if (typeof nuxt_plugin_storage_8f945902 === 'function') {
    await nuxt_plugin_storage_8f945902(app.context, inject)
  }

  if (typeof nuxt_plugin_libpluginc1def7bc_f826a572 === 'function') {
    await nuxt_plugin_libpluginc1def7bc_f826a572(app.context, inject)
  }

  if (typeof nuxt_plugin_libmoduleplugin1e0320f0_6470ca13 === 'function') {
    await nuxt_plugin_libmoduleplugin1e0320f0_6470ca13(app.context, inject)
  }

  if (typeof nuxt_plugin_srcplugintemplate54deb667_2c7671fc === 'function') {
    await nuxt_plugin_srcplugintemplate54deb667_2c7671fc(app.context, inject)
  }

  if (typeof nuxt_plugin_sanity_3e989426 === 'function') {
    await nuxt_plugin_sanity_3e989426(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_d82bb6cc === 'function') {
    await nuxt_plugin_globalcomponents_d82bb6cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_388ffffe === 'function') {
    await nuxt_plugin_polyfills_388ffffe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gsap_559c063e === 'function') {
    await nuxt_plugin_gsap_559c063e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtpreviewinit_3853c50e === 'function') {
    await nuxt_plugin_nuxtpreviewinit_3853c50e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_6a810249 === 'function') {
    await nuxt_plugin_gtag_6a810249(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_refersion_19172fa2 === 'function') {
    await nuxt_plugin_refersion_19172fa2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_klaviyo_e863c0ba === 'function') {
    await nuxt_plugin_klaviyo_e863c0ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amazon_4614db4a === 'function') {
    await nuxt_plugin_amazon_4614db4a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_522b5bf4 === 'function') {
    await nuxt_plugin_hotjar_522b5bf4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_c32a0d60 === 'function') {
    await nuxt_plugin_vueobservevisibility_c32a0d60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuea11yutils_30229ae9 === 'function') {
    await nuxt_plugin_vuea11yutils_30229ae9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_09a6108f === 'function') {
    await nuxt_plugin_vueawesomeswiper_09a6108f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_81ef739a === 'function') {
    await nuxt_plugin_veevalidate_81ef739a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclickoutside_7f633153 === 'function') {
    await nuxt_plugin_vueclickoutside_7f633153(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemovedom_5bbf3e73 === 'function') {
    await nuxt_plugin_vuemovedom_5bbf3e73(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueodometer_4b94e888 === 'function') {
    await nuxt_plugin_vueodometer_4b94e888(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefontawesome_168dae32 === 'function') {
    await nuxt_plugin_vuefontawesome_168dae32(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehoverintent_460e36fa === 'function') {
    await nuxt_plugin_vuehoverintent_460e36fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aspire_466ffa64 === 'function') {
    await nuxt_plugin_aspire_466ffa64(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_2c6065c7 === 'function') {
    await nuxt_plugin_eventbus_2c6065c7(app.context, inject)
  }

  if (typeof nuxt_plugin_sanityimage_65558462 === 'function') {
    await nuxt_plugin_sanityimage_65558462(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sanitystudio_56d72faf === 'function') {
    await nuxt_plugin_sanitystudio_56d72faf(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_5e48f842 === 'function') {
    await nuxt_plugin_dayjs_5e48f842(app.context, inject)
  }

  if (typeof nuxt_plugin_numeral_3a7ded98 === 'function') {
    await nuxt_plugin_numeral_3a7ded98(app.context, inject)
  }

  if (typeof nuxt_plugin_slugify_3412fbeb === 'function') {
    await nuxt_plugin_slugify_3412fbeb(app.context, inject)
  }

  if (typeof nuxt_plugin_pluralize_5e64ff6c === 'function') {
    await nuxt_plugin_pluralize_5e64ff6c(app.context, inject)
  }

  if (typeof nuxt_plugin_sanitymixin_658c6788 === 'function') {
    await nuxt_plugin_sanitymixin_658c6788(app.context, inject)
  }

  if (typeof nuxt_plugin_colormixin_6ac7ffde === 'function') {
    await nuxt_plugin_colormixin_6ac7ffde(app.context, inject)
  }

  if (typeof nuxt_plugin_textareaautogrowdirective_50d87671 === 'function') {
    await nuxt_plugin_textareaautogrowdirective_50d87671(app.context, inject)
  }

  if (typeof nuxt_plugin_vueresizeobserver_dccea3fc === 'function') {
    await nuxt_plugin_vueresizeobserver_dccea3fc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
